
<div class="radio-list">
      <label *ngFor="let option of options">
        <app-form-radio [skill]="skill" [value]="option.id" [isChecked]="skill.selectedOption == option.id" (radioChanged$)="onRadioChange($event)"></app-form-radio>
        <span>{{option.name}}</span>
    </label>
</div>
